import { render, staticRenderFns } from "./VModelBoolean.vue?vue&type=template&id=7f15e4fe"
import script from "./VModelBoolean.vue?vue&type=script&lang=js"
export * from "./VModelBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports